/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';
import { generateInnerHtml } from '@blend/shared-react';

const styles = StyleSheet.create({
  taskMessageSecondaryHeading: {
    color: colors.darkerGray,
    fontSize: 16,
  },
});

export namespace TaskMessageSecondaryHeading {
  export interface Props {
    display: string;
  }
}
export const TaskMessageSecondaryHeading: React.FC<TaskMessageSecondaryHeading.Props> = ({ display }) => (
  <p className={css(styles.taskMessageSecondaryHeading)} {...generateInnerHtml(display)} />
);
